import React from 'react';

const Employee = () => {
  return (
    <div>
      Employee
      Employee
    </div>
  );
}

export default Employee;
